import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { getPercentage } from 'helpers';
import { useMemo } from 'react';

export default function SettingsStats() {
    const game = useGame();

    const actions = useMemo(() => {
        return game.actions.slice().reverse();
    }, [game.actions]);

    return (
        <Box display="flex" flexDirection="row" gap={4}>
            <Box flex={1}>
                <Typography paragraph>Stats</Typography>
                <Table padding="none" size="small">
                    <TableBody>
                        <TableRow>
                            <TableCell>Hands</TableCell>
                            <TableCell>{game.hands}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Round</TableCell>
                            <TableCell>{game.round}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Round cost</TableCell>
                            <TableCell>${game.roundCost}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Hole hand</TableCell>
                            <TableCell>{game.holeHandName}</TableCell>
                        </TableRow>
                        {game.opponentsHandNames.map((opponentHandName, index) => (
                            <TableRow key={index}>
                                <TableCell>Opponent {index + 1} hand</TableCell>
                                <TableCell>{opponentHandName}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell>Win probability</TableCell>
                            <TableCell>{getPercentage(game.winProbability)}%</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Expected pot</TableCell>
                            <TableCell>${game.expectedPot.toFixed(2)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Expected value</TableCell>
                            <TableCell>${game.expectedValue.toFixed(2)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Remaining costs</TableCell>
                            <TableCell>${game.remainingCosts}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Should pay</TableCell>
                            <TableCell>{game.shouldPay ? 'Yes' : 'No'}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>

            <Box flex={3}>
                <Typography paragraph>Actions</Typography>
                <Box height={200} overflow="auto">
                    <Table padding="none" size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Round</TableCell>
                                <TableCell>Budget</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Opponent</TableCell>
                                <TableCell>Correct</TableCell>
                                <TableCell>Intercepted</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {actions.map((action, index) => (
                                <TableRow key={index}>
                                    <TableCell>{actions.length - index}</TableCell>
                                    <TableCell>{action.round}</TableCell>
                                    <TableCell>{action.budget}</TableCell>
                                    <TableCell>{action.type}</TableCell>
                                    <TableCell>{action.opponent}</TableCell>
                                    <TableCell>{action.correct ? 'Yes' : 'No'}</TableCell>
                                    <TableCell>{action.intercept}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </Box>
    );
}
